const inits = {
  activeTool: 'oilpalm',
  toolData: {
    gcList: [],
    nameList: [],
    types: [],
    districts: [],
    provinces: [],
    countries: [],
  }
}

const ToolReducer = (s = inits, action) => {
  const {payload} = action
  switch (action.type) {
    case '_TOOL':
      return { ...s, [payload[0]]: payload[1] }

    case 'SET_TOOL_DATA':
      return { ...s,
        toolData: payload ? {...s.toolData,...payload} : s.toolData,
      }

    default:
      return s;
  }
};
export default ToolReducer
